export default {
  activeBorderColor: Styles.color.primary,
  backgroundColor: Styles.color.white,
  inactiveBorderColor: Styles.color.grey.four,
};
